<template>
  <v-row>
    <v-col cols="12">
      <BaseFilter
        v-model="search"
        v-bind="defaultFilterProps"
        textPlaceholder="Buscar"
        @search="searchByFilter"
        v-on:keyup="searchByFilterClickEnter"
      />
    </v-col>
    <v-col cols="12">
      <BaseDataTable
        :headers="tableHeaders"
        :items="quotations.items"
        :server-items-length="quotations.total_count"
        no-data-text="Não há limites cadastrados."
        :options.sync="filterOptions"
        class="eg-table"
        @click:row="goToCreditLimitConsult"
      >
        <template v-slot:[`item.solicitado_em`]="{ item }">
          {{ formatWaitingDate(item.consulta_gerada_em) }}
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import {
  CommonPayload as ResourceFilterMixin,
  defaultFilterOptions
} from "@/mixins/PayloadDataTableMixin";
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
const tableHeaders = [
  { text: "Referência", value: "grupo_economico.referencia", sortable: true },
  { text: "Nome", value: "grupo_economico.nome", sortable: true },
  { text: "Seguradora", value: "seguradora.nome", sortable: true },
  { text: "Aguardando retorno", value: "solicitado_em", sortable: true }
];
import { differenceInDays } from "date-fns";
export default {
  data: () => ({
    tableHeaders,
    defaultFilterProps,
    search: null,
    filterOptions: defaultFilterOptions(),
    differenceInDays
  }),
  mixins: [LoadingRequest, ResourceFilterMixin],
  computed: {
    ...mapState("economic_group", ["quotations"])
  },
  methods: {
    ...mapActions("economic_group", [
      "selectCreditLimitConsult",
      "listInsurerQuotations"
    ]),
    searchByFilter() {
      this.performFilter(this.toLSPFilter(this.filterOptions, this.search));
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13) this.searchByFilter();
    },
    performFilter(filter) {
      this.withLoading(this.listInsurerQuotations(filter));
    },
    goToCreditLimitConsult(item) {
      this.selectCreditLimitConsult(item);
      this.$router.push({
        name: "economic_group credit_limit consult",
        params: {
          groupId: item.grupo_economico.id,
          consultId: item.id
        }
      });
    },
    formatWaitingDate(date) {
      const today = new Date();
      const waitingDate = new Date(date);
      const result = differenceInDays(today, waitingDate);
      return `${result} dias`;
    }
  },
  watch: {
    filterOptions: {
      handler(value) {
        this.performFilter(this.toLSPFilter(value, this.search));
      },
      deep: true
    }
  }
};
</script>
